module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"exam":"Prüfung","noDocumentsAvailable":"Keine Dokumente vorhanden","startNow":"Jetzt beginnen"},"en":{"exam":"Exam","noDocumentsAvailable":"No documents available","startNow":"Start now"}}')
  delete Component.options._Ctor
}
